<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_savings'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">

              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>
                    Filter</b-button></div>
              </div>
              <span v-show="userData.permissions['new_savings'] == 1" class="mt-4"><b-button v-b-modal.new-saving
                  variant="primary" type="button" class="btn-sm btn"><i class="mdi mdi-plus"></i> New
                  Savings</b-button></span>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/member-profile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>

                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                <template #cell(mode_of_payment)="data">
                  {{ data.item.mode_of_payment.name }}<br>
                  <b class="text-info">{{ data.item.mode_of_payment.account_number }}</b>
                </template>
                <template #cell(approval)="data">
                  <span class="text-info" v-if="data.item.status == 2">
                    <b-button class="btn-sm" variant="light">Approved</b-button>
                  </span>
                  <span v-else>
                    <b-button v-show="userData.permissions['approve_savings'] == 1"
                      @click="approve(data.item.id, data.item.member, data.item.amount, data.item.mode_of_payment, data.item.reference, data.item.date_of_payment)"
                      type="button" class="btn-sm" variant="primary" v-b-modal.edit>Approve</b-button>
                  </span>
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex gap-1">
                    <b-button v-show="data.item.status == 2" class="btn btn-sm" variant="primary"
                      @click="$router.push({ path: '/print-saving', query: { id: data.item.id } })">
                      <i class="mdi mdi-printer"></i> <span v-if="userData.permissions['is_super_admin'] != 1">Print</span>
                    </b-button>
                    <b-button
                      v-show="(userData.permissions['edit_savings'] == 1 && data.item.status == 1) || userData.permissions['is_super_admin'] == 1"
                      @click="edit(data.item.id, data.item.member.member_id, data.item.amount, data.item.mode_of_payment.id, data.item.reference, data.item.date_of_payment)"
                      type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i
                        class="mdi mdi-square-edit-outline"></i> </b-button>
                    <b-button v-show="(userData.permissions['edit_savings'] == 1 && data.item.status == 1) || userData.permissions['is_super_admin'] == 1"
                      @click="remove(data.item.id, data.item.member.name)" type="button" class="btn-sm btn"
                      variant="danger" v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Savings : {{ commas(totalsavings) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Savings</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-saving" centered title="New Savings" title-class="font-18" hide-footer>
      <form @submit.prevent="addSaving">
        <div class="form-group mb-2">
          <label>Member</label> <small class="text-danger">*</small>
          <v-select :options="members" placeholder="Select an Option" @input="FindPackage()" v-model="member"
            label="name" :reduce="member => member.member_id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Member ID</label>
          <input v-model="member" type="text" readonly class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Transaction Amount</label> <small class="text-danger">*</small>
          <input v-model="amount" type="number" required class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Reference</label>
          <textarea v-model="reference" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label> <small class="text-danger">*</small>
          <input v-model="date_of_payment" :max="currentdate" required type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-saving')">Close</b-button>
          <b-button type="submit" :disabled="saveBtn" class="btn ms-1 w-30" variant="primary">
            <b-spinner v-if="saveBtn" small></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            Submit
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-saving" centered title="Edit Saving" title-class="font-14" hide-footer>
      <form @submit.prevent="editSaving">
        <div class="form-group mb-2">
          <label>Member</label> <small class="text-danger">*</small>
          <v-select :options="members" placeholder="Select an Option" v-model="member" label="name"
            :reduce="member => member.member_id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Member ID</label> <small class="text-danger">*</small>
          <input v-model="member" type="text" readonly class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Transaction Amount</label> <small class="text-danger">*</small>
          <input v-model="amount" type="number" required class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Reference</label>
          <textarea v-model="reference" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label> <small class="text-danger">*</small>
          <input v-model="date_of_payment" :max="currentdate" required type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-saving')">Close</b-button>
          <b-button type="submit" :disabled="editBtn" class="btn ms-1 w-30" variant="primary">
            <b-spinner v-if="editBtn" small></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            Submit
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="approve-saving" centered title="Are you sure you want to Approve Saving" title-class="font-14"
      hide-footer>
      <form @submit.prevent="approveSaving">
        <div class="form-group mb-2">
          <label>Member : </label>
          <h5><span class="text-info h5" v-html="member"></span> - <span class="text-info h5"
              v-html="membername"></span>
          </h5>
        </div>
        <div class="form-group mb-2">
          <label>Transaction Amount</label>
          <h5 class="text-info" v-html="commas(amount)"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label>
          <h5 class="text-info" v-html="mode_of_payment.name"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Reference</label>
          <h5 class="text-info" v-html="reference"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label>
          <h5 class="text-info" v-html="date_of_payment"></h5>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('approve-saving')">Close</b-button>
          <b-button type="submit" :disabled="approveBtn" class="btn ms-1 w-30" variant="primary">
            <b-spinner v-if="approveBtn" small></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            Submit
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-saving" centered title="Delete Saving" title-class="font-18" hide-footer>
      <form @submit.prevent="removeSaving">
        <input v-model="id" type="hidden">
        Are you sure you want to delete the Saving for : <b>{{ membername }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-saving')">Close</b-button>
          <b-button type="submit" :disabled="removeBtn" class="btn ms-1 w-30" variant="primary">
            <b-spinner v-if="removeBtn" small></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            YES
          </b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { savingMethods, savingComputed, memberMethods, memberComputed, paymentoptionMethods, paymentoptionComputed } from "@/state/helpers";

export default {
  page: {
    title: "Savings",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Savings",
      items: [{ text: "Dashboard", to: "/", }, { text: "Savings", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'member', label: 'Name', visible: true },
        { key: 'amount', label: 'Amount', visible: true },
        { key: 'mode_of_payment', label: 'Mode of Payment', visible: true },
        { key: 'reference', label: 'Reference', visible: true },
        { key: 'date_of_payment', label: 'Date of Payment', visible: true },
        { key: 'addedby', label: 'Added by', visible: true },
        { key: 'approval', label: 'Approval', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      member: '',
      amount: '',
      mode_of_payment: '',
      reference: '',
      date_of_payment: new Date().toLocaleDateString('fr-CA'),
      membername: '',
      saveBtn: false,
      editBtn: false,
      approveBtn: false,
      removeBtn: false,
      saveError: '',
      currentdate: new Date().toLocaleDateString('fr-CA'),
      date_to: new Date().toLocaleDateString('fr-CA'),
      date_from: new Date().toLocaleDateString('fr-CA'),
      name_hover: false,
      current_index: null,
    };
  },
  computed: {
    ...savingComputed,
    ...memberComputed,
    ...paymentoptionComputed,
    List() { return this.savings.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.savings.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.savings.length > 0) { a = false; } else { a = true; } return a },
    totalsavings() { var total = 0; this.savings.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
  },
  mounted() {
    this.fetchSavings();
    this.fetchMembers();
    this.fetchPaymentoptions();
    this.TotalRows = this.savings.length;
    this.isBusy = false;
    // this.mode_of_payment = this.paymentoptions.find(option => option.set_default == 1);
  },
  methods: {
    ...savingMethods,
    ...memberMethods,
    ...paymentoptionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async addSaving() {
      if (!this.member || !this.amount || !this.mode_of_payment || !this.date_of_payment) {
        this.$toast.error("Please fill in all required fields");
        return;
      }

      this.saveBtn = true;
      this.saveError = "Saving Member Savings";
      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("amount", this.amount);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("reference", this.reference);
      formData.append("date_of_payment", this.date_of_payment);
      let url = "/addsaving";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchSavings();
            this.$bvModal.hide('new-saving');
            this.clearFields();
            this.$toast.success("New Member Saving Added");
          }
        });
      } finally {
        this.saveBtn = false;
        this.saveError = "";
      }
    },
    edit(id, member, amount, mode_of_payment, reference, date_of_payment) {
      this.id = id;
      this.member = member;
      this.amount = amount;
      this.mode_of_payment = mode_of_payment;
      this.reference = reference;
      this.date_of_payment = date_of_payment;
      this.$bvModal.show('edit-saving')
    },
    approve(id, member, amount, mode_of_payment, reference, date_of_payment) {
      this.id = id;
      this.member = member.member_id;
      this.membername = member.name;
      this.amount = amount;
      this.mode_of_payment = mode_of_payment;
      this.reference = reference;
      this.date_of_payment = date_of_payment;
      this.$bvModal.show('approve-saving')
    },
    remove(id, member) {
      this.id = id;
      this.membername = member;
      this.$bvModal.show('delete-saving')
    },
    async editSaving() {
      if (!this.member || !this.amount || !this.mode_of_payment || !this.date_of_payment) {
        this.$toast.error("Please fill in all required fields");
        return;
      }

      this.editBtn = true;
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("member", this.member);
      formData.append("amount", this.amount);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("reference", this.reference);
      formData.append("date_of_payment", this.date_of_payment);
      let url = "/updatesaving";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchSavings();
            this.$bvModal.hide('edit-saving');
            this.clearFields();
          }
        });
      } finally {
        this.editBtn = false;
      }
    },

    clearFields() {
      this.member = "";
      this.amount = "";
      this.reference = "";
      this.date_of_payment = new Date().toISOString().split('T')[0];
      this.mode_of_payment = "";
    },

    async approveSaving() {
      this.approveBtn = true;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/approvesaving";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchSavings();
            this.$bvModal.hide('approve-saving');
            this.$toast.success("Saving Approved");
            this.clearFields();
          }
        });
      } finally {
        this.approveBtn = false;
      }
    },
    async removeSaving() {
      this.removeBtn = true;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesaving";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchSavings();
            this.$bvModal.hide('delete-saving');
            this.clearFields();
          }
        });
      } finally {
        this.removeBtn = false;
      }
    },
    async FindPackage() {
      let formData = new FormData();
      formData.append("member", this.member);
      let url = "/findsavingpackage";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.amount = response.data.packages[0].amount;
        }
      });
    },
    FilterData() {
      this.filterSavings({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>